export default {
    ReturnRefundToBeReviewed: {
        OrderNo: '退款单号/销售单号',
        Document: '退货单来源',
        Return: '退货物流公司',
        Nickname: '买家昵称',
        Returned: '退货人',
        Tripartite: '三方退货时间',
        Approved: '审核通过',
        Approval: '审核拒绝',
        form: {
            number: '内部退货单号',
            return: '三方退货单号',
            Third: '客户订单号',
            order: '内部订单号',
            Returntype: '退货单类型',
            Type: '退货类型',
            status: '订单状态',
            Approval: '审核状态',
            Doc: '退货单来源',
            refund: '退货退款原因',
            comments: '买家备注',
            Customer: '客服备注',
            quantity: '退货数量',
            Total: '应退买家合计',
            Settlement: '结算方式',
            warehouse: '收货仓库',
            information: '退货物流信息',
            nickname: '买家昵称',
            Returned: '退货人',
            person: '退货人手机号',
            address: '退货人地址',
            store: '销售店铺',
            channel: '销售渠道',
            returntime: '三方退货时间',
            creation: '内部创单时间',
            completion: '退货完成时间',
        },
    }
};
